module.exports = __webpack_public_path__ + "img/try-two.34ea8941.png";